/* eslint-disable no-restricted-syntax */
function getType(val) {
  if (typeof val === 'string') return 'String';
  if (typeof val === 'number') return Number.isInteger(val) ? 'int' : 'double';
  if (typeof val === 'boolean') return 'boolean';
  if (Array.isArray(val)) return 'List<Object>';
  if (typeof val === 'object' && val !== null) return 'Object';
  return 'String';
}

function toCamelCase(str) {
  return str.replace(/_([a-z])/g, (_, g) => g.toUpperCase());
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const generateGsonPojo = (
  jsonObj,
  packageName,
  className,
  withAccessors = true,
) => {
  const fields: any = [];
  const methods: any = [];

  for (const key of Object.keys(jsonObj)) {
    const value = jsonObj[key];
    const type = getType(value);
    const camelCaseKey = toCamelCase(key);

    fields.push(`   @SerializedName("${key}")\n   ${type} ${camelCaseKey};`);

    if (withAccessors) {
      methods.push(
        `    public void set${capitalize(
          camelCaseKey,
        )}(${type} ${camelCaseKey}) {\n` +
          `        this.${camelCaseKey} = ${camelCaseKey};\n    }\n`,
      );
      methods.push(
        `    public ${type} get${capitalize(camelCaseKey)}() {\n` +
          `        return ${camelCaseKey};\n    }\n`,
      );
    }
  }

  return `
package ${packageName};

import com.google.gson.annotations.SerializedName;

public class ${className} {

${fields.join('\n\n')}

${withAccessors ? methods.join('\n') : ''}
}`.trim();
};
